import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useIncidenceMessageStats } from 'modules/bookkeepers/hooks/IncidenceMessageStatsContext'
import { useIncidenceStats } from 'modules/bookkeepers/hooks/IncidenceStatsContext'
import { INCIDENCE_STATUSES } from 'modules/payroll_bundle/lib/Incidences/Status'

import StatsByStatus from '../_Stats/_ByStatus'
import StatsMessages from '../_Stats/_Messages'

const ProStats = () => {
  const incidenceStats = useIncidenceStats()
  const messageStats = useIncidenceMessageStats()

  return (
    <>
      <StatsByStatus
        stats={incidenceStats}
        status={INCIDENCE_STATUSES.in_preparation}
        label={i18n.t('bookkeepers.incidence.status.in_preparation_admin')}
        hasBorder
      />
      <StatsMessages stats={messageStats} />
    </>
  )
}

export default observer(ProStats)
